import { mapGetters } from 'vuex';

const DEFAULT_ORGANIZATION = 'ESH37';

function PageTracking(initOptions = {}) {
  const options = {
    trackViewOnMount: true,
    updateLinkTrackingOnMount: true,
    ...initOptions,
  };
  return {
    computed: {
      ...mapGetters('cart', ['couponCampaignName', 'couponRedeemed']),
      tealiumPageType() {
        return 'theme';
      },
      tealiumPageContentIdFromPath() {
        return this.$route.path.split('/').slice(1).join('.').replace('_', '');
      },
      tealiumPageContentId() {
        return this.tealiumPageContentIdFromPath;
      },
      tealiumData() {
        return {
          page_type: this.tealiumPageType,
          page_content_id: `shop.telekom.de.privatkunden.${this.tealiumPageContentId}`,
          page_technical_id: '',
          login_status: 'not-logged-in',
          shop_customer_type: 'nicht-bestandskunde',
          ...this.additionalTealiumData,
          shop_mlid: '',
          shop_vb: '',
          shop_vo: DEFAULT_ORGANIZATION,
          shop_vpnr: '',
          shop_gutschein_kampagne: this.couponCampaignName,
          shop_gutschein_vorhanden: this.couponRedeemed ? 'ja' : 'nein',
        };
      },
      additionalTealiumData() {
        return {};
      },
    },
    mounted() {
      if (this.$tealium) {
        if (options.trackViewOnMount) {
          this.$tealium.view(this.tealiumData);
        }
        if (options.updateLinkTrackingOnMount) {
          this.$tealium.updateAutomaticLinkTracking();
        }
      }
    },
  };
}

PageTracking.Default = PageTracking();

export default PageTracking;
